import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FormikProps } from "formik";
import { FormValues } from "../types";

interface TaxesSectionProps {
  formik: FormikProps<FormValues>;
}

export const TaxesSection = ({ formik }: TaxesSectionProps) => (
  <>
    <div>
      <span className="simulacao-form-header">Dados de impostos</span>
      <hr />
    </div>

    <div className="formLine">
      <Form.Group
        controlId="icms"
        style={{ width: "100%", maxWidth: "375px", height: "80px" }}
      >
        <Form.Label className="simulacao-form-title">
          ICMS <span>*</span>
        </Form.Label>
        <InputGroup className="mb-3">
          <Form.Control
            name="icms"
            placeholder="Porcentagem"
            onBlur={formik.handleBlur}
            value={formik.values.icms}
            onChange={formik.handleChange}
            isInvalid={!!formik.touched.icms && !!formik.errors.icms}
            min={0}
            max={100}
          />
          <InputGroup.Text>%</InputGroup.Text>
          <Form.Control.Feedback type="invalid">
            {formik.errors.icms}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      <Form.Group
        controlId="pis"
        style={{ width: "100%", maxWidth: "375px", height: "80px" }}
      >
        <Form.Label className="simulacao-form-title">
          PIS <span>*</span>
        </Form.Label>
        <InputGroup className="mb-3">
          <Form.Control
            name="pis"
            placeholder="Porcentagem"
            onBlur={formik.handleBlur}
            value={formik.values.pis}
            onChange={formik.handleChange}
            isInvalid={!!formik.touched.pis && !!formik.errors.pis}
            min={0}
            max={100}
          />
          <InputGroup.Text>%</InputGroup.Text>
          <Form.Control.Feedback type="invalid">
            {formik.errors.pis}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      <Form.Group
        controlId="cofins"
        style={{ width: "100%", maxWidth: "375px", height: "80px" }}
      >
        <Form.Label className="simulacao-form-title">
          COFINS <span>*</span>
        </Form.Label>
        <InputGroup className="mb-3">
          <Form.Control
            name="cofins"
            placeholder="Porcentagem"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.cofins}
            isInvalid={!!formik.touched.cofins && !!formik.errors.cofins}
            min={0}
            max={100}
          />
          <InputGroup.Text>%</InputGroup.Text>
          <Form.Control.Feedback type="invalid">
            {formik.errors.cofins}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </div>
  </>
);
